<script lang="ts" setup>
import AdminMenu from '@/layouts/admin/AdminMenu.vue'
import {useLayout} from "@/layouts/admin/layout.ts";

defineProps<{
  isSidebarExpanded: boolean
}>()

const { closeMenu } = useLayout()
</script>

<template>
  <div class="layout-sidebar pt-4">
    <AdminMenu :is-sidebar-expanded="isSidebarExpanded" @link-clicked="closeMenu"/>
  </div>
</template>

<style lang="scss" scoped></style>
